
export enum BrowseAppEvents {
    ShowAppLoadingWithMessage = 'BrowseApp.ShowAppLoadingWithMessage',
    ShowAppReady = 'BrowseApp.ShowAppReady',
}
